var exports = {
  "R": "alertTitle__AsQQCd",
};

module.exports = exports;
